<h1 class="hp-tt">Historial de puntos</h1>
<p class="hp-sub">De dónde salió cada punto, cuándo se acreditó y cuándo vence.</p>

<loading-indicator *ngIf="isLoading"></loading-indicator>

<ng-container *ngIf="cargado && !isLoading">

  <div class="hp-vacio" *ngIf="error">
    <p>No pudimos cargar tu historial de puntos.</p>
    <span>Probá de nuevo en un rato.</span>
  </div>

  <ng-container *ngIf="!error">

    <!-- Aviso de lo que esta por vencer, arriba de todo como en el prototipo. -->
    <div class="hp-aviso" *ngIf="hayPorVencer">
      <b>{{ puntosPorVencer | number:'1.0-0':'es-AR' }} puntos tuyos vencen
        el {{ proximoVencimiento | date:'d \'de\' MMMM':'':'es-AR' }}.</b>
    </div>

    <ng-container *ngIf="hayMovimientos">

      <!-- Desktop: tabla. -->
      <table class="hp-tabla">
        <thead>
          <tr>
            <th class="hp-c-fecha">Fecha</th>
            <th>Concepto</th>
            <th class="hp-c-pts">Puntos</th>
            <th class="hp-c-vence">Vencen</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let m of movimientos" [class.porvencer]="m.porVencer">
            <td>{{ m.fecha | date:'d \'de\' MMMM \'de\' y':'':'es-AR' }}</td>
            <td>{{ concepto(m) }}</td>
            <td class="hp-c-pts hp-pts" [matTooltip]="desglose(m)" matTooltipPosition="left">
              {{ m.puntos >= 0 ? '+' : '' }}{{ m.puntos | number:'1.0-0':'es-AR' }}
            </td>
            <td class="hp-c-vence">{{ m.vence | date:'d \'de\' MMMM \'de\' y':'':'es-AR' }}</td>
          </tr>
        </tbody>
      </table>

      <!-- Mobile: lista de tarjetas. -->
      <div class="hp-lista">
        <div class="hp-mov" *ngFor="let m of movimientos" [class.porvencer]="m.porVencer">
          <div class="hp-info">
            <b>{{ concepto(m) }}</b>
            <span>
              {{ m.fecha | date:'d \'de\' MMMM':'':'es-AR' }}
              <ng-container *ngIf="m.vence"> · vence el {{ m.vence | date:'dd/MM/y':'':'es-AR' }}</ng-container>
            </span>
          </div>
          <div class="hp-pts" [matTooltip]="desglose(m)">{{ m.puntos >= 0 ? '+' : '' }}{{ m.puntos | number:'1.0-0':'es-AR' }}</div>
        </div>
      </div>

    </ng-container>

    <div class="hp-vacio" *ngIf="!hayMovimientos">
      <p>Todavía no tenés movimientos de puntos.</p>
      <span>Cuando hagas tu primera compra identificándote, la vas a ver acá.</span>
    </div>

  </ng-container>

</ng-container>
